(function () {
  function appendParamsToUrl(url) {
    if (window.pcLandingUtm && typeof window.pcLandingUtm.appendToUrl === 'function') {
      return window.pcLandingUtm.appendToUrl(url);
    }
    return url;
  }

  class LandingSection {
    constructor(section) {
      this.section = section;
      // Map of variantId (string) -> { qty, price (cents), qtyEl }
      this.state = new Map();

      this.totalEl      = section.querySelector('[data-lpg-total]');
      this.checkoutBtn  = section.querySelector('[data-lpg-checkout]');

      this.initRows();
      this.initCheckout();
    }

    // — Product rows —

    initRows() {
      this.section.querySelectorAll('[data-lpg-row]').forEach((row) => {
        const variantId = row.dataset.variantId;
        const price     = parseInt(row.dataset.price, 10) || 0;
        const qtyEl     = row.querySelector('[data-lpg-qty]');

        this.state.set(variantId, { qty: 0, price, qtyEl });

        row.querySelector('[data-lpg-plus]').addEventListener('click', () => {
          const s = this.state.get(variantId);
          s.qty++;
          qtyEl.textContent = s.qty;
          this.updateTotal();
        });

        row.querySelector('[data-lpg-minus]').addEventListener('click', () => {
          const s = this.state.get(variantId);
          if (s.qty > 0) {
            s.qty--;
            qtyEl.textContent = s.qty;
            this.updateTotal();
          }
        });
      });
    }

    // — Running total —

    updateTotal() {
      let totalCents = 0;
      let itemCount  = 0;
      this.state.forEach(({ qty, price }) => {
        totalCents += qty * price;
        itemCount  += qty;
      });

      if (this.totalEl) {
        this.totalEl.textContent = (totalCents / 100).toLocaleString('en-US', {
          style   : 'currency',
          currency: 'USD'
        });
      }

      if (this.checkoutBtn) {
        if (itemCount > 0) {
          this.checkoutBtn.removeAttribute('disabled');
        } else {
          this.checkoutBtn.setAttribute('disabled', 'disabled');
        }
      }
    }

    // — Checkout —

    initCheckout() {
      if (this.checkoutBtn) {
        this.checkoutBtn.addEventListener('click', () => this.checkout());
      }
    }

    async checkout() {
      const btn = this.checkoutBtn;
      if (btn) {
        btn.setAttribute('disabled', 'disabled');
        btn.classList.add('loading');
      }

      const items = [];
      this.state.forEach(({ qty }, variantId) => {
        if (qty > 0) {
          items.push({ id: parseInt(variantId, 10), quantity: qty });
        }
      });

      if (!items.length) return;

      try {
        const res = await fetch('/cart/add.js', {
          method : 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body   : JSON.stringify({ items })
        });
        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.description || 'Unable to add to cart');
        }
        window.location.href = appendParamsToUrl('/checkout');
      } catch (err) {
        console.error(err);
        alert(err.message);
        if (btn) {
          btn.removeAttribute('disabled');
          btn.classList.remove('loading');
        }
      }
    }
  }

  function initGalleries() {
    document.querySelectorAll('[data-lpg-gallery]').forEach((gallery) => {
      const imgs   = Array.from(gallery.querySelectorAll('[data-lpg-gallery-img]'));
      const thumbs = Array.from(gallery.querySelectorAll('[data-lpg-gallery-thumb]'));

      if (imgs.length < 2) return;

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const idx = parseInt(thumb.dataset.index, 10);

          imgs.forEach((img, i) => img.classList.toggle('lpg-gallery__img--active', i === idx));
          thumbs.forEach((t, i) => t.classList.toggle('lpg-gallery__thumb--active', i === idx));
        });
      });
    });
  }

  function initDescToggles() {
    document.querySelectorAll('[data-lpg-desc-toggle]').forEach((btn) => {
      const desc = btn.closest('.lpg-row__desc-wrap').querySelector('[data-lpg-desc]');
      if (!desc) return;

      const checkClamp = () => desc.scrollHeight > desc.clientHeight + 2;

      const update = () => {
        if (checkClamp() || desc.classList.contains('is-expanded')) {
          btn.classList.add('is-visible');
        }
      };

      update();

      btn.addEventListener('click', () => {
        const expanded = desc.classList.toggle('is-expanded');
        btn.setAttribute('aria-expanded', expanded);
        btn.textContent = expanded ? 'Read less' : 'Read more';
      });
    });
  }

  function init() {
    document.querySelectorAll('.landing-product-grid[data-section-id]').forEach((section) => {
      new LandingSection(section);
    });
    initGalleries();
    initDescToggles();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
